// @flow
import React from 'react'
import styled from 'styled-components'

const Title = styled.span`
  font-weight: bold;
  height: 20px;
  padding-right: 4px;
`

type Props = {|
  title: string,
  children: Array<Object>
|}

export default function Line(props: Props) {
  const { title, children } = props

  return (
    <div>
      {children && children.length > 0 && title && <Title>{title}: </Title>}
      {children}
    </div>
  )
}
